import { render } from "./WithdrawalRecord.vue?vue&type=template&id=637f4e2a&scoped=true"
import script from "./WithdrawalRecord.vue?vue&type=script&lang=js"
export * from "./WithdrawalRecord.vue?vue&type=script&lang=js"

import "./WithdrawalRecord.vue?vue&type=style&index=0&id=637f4e2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637f4e2a"]])

export default __exports__